<template>
  <div class="item-added">
    <p :class="dataClass">
      {{ text }}
      <v-icon
        class="toggleIcon mr-2 cursorPointer"
        v-if="showDelete"
        @click="clickEvent"
        >close</v-icon
      >
    </p>
  </div>
</template>

<script>
export default {
  props: {
    showDelete: Boolean,
    clickFunction: Function,
    dataClass: String,
    text: String
  },
  methods:{
    clickEvent() {
      if (this.clickFunction) {
        this.clickFunction();
      }
      this.$emit('click');
    }
  },
  mounted() {
  }
};
</script>

<style scoped>
.item-added {
  width: max-content;
  float: left;
  margin-right: 6px;
  margin-top: 10px;
  color: white;
}

.item-added p {
  font-weight: 600;
  line-height: 12px;
  text-align: left;
  margin: 0;
  display: inline-block;
}

.toggleIcon {
  font-size: 10px !important;
  margin: 0 !important;
  line-height: 1.1 !important;
  color: white;
}
</style>
